import React from 'react';
import PropTypes from 'prop-types';
import ResultsPaginator from './ResultsPaginator';

const PetitionResults = ({ data, filter, onSearch, onGetPetitionPdf }) => {
  const onPetitionClick = (event, row) => {
    event.preventDefault();
    const params = {
      court_code: row.case_court,
      case_no: row.case_no,
    };
    onGetPetitionPdf(params);
  };

  return (
    <div id="ir-search-search-premium-results">
      <h2>
        Results – {data.num_cases} {data.num_cases > 1 ? 'cases' : 'case'}
      </h2>
      {data.results.map((row, idx) => {
        const case_url = `/rpc/legacy/case-menu-redirect/${row.case_court}/${row.case_no}`;

        return (
          <div key={idx} className="result-item result-item-case-extended">
            <h3 className="result-item-header">
              {row.case_title}
              {' | '}
              <a href={case_url} title="Go to Case Query Menu" target="_blank">
                {row.case_no}
              </a>
              {' | '}
              {row.case_court}
              {' | '}
              Chp. {row.case_chapter}
              {' | '}
              {row.date_filed || row.date_closed}
              {' | '}
              Business BK Filings
            </h3>
            <div className="result-item-section result-item-body">
              <span className="result-case-extended-info">
                <h4>Assets: </h4>
                {row.assets}
              </span>
              <span className="result-case-extended-info">
                <h4>Liabilities: </h4>
                {row.liabilities}
              </span>
              <span className="result-case-extended-info">
                <h4>Industry: </h4>
                {row.industry || 'Unknown'}
              </span>
            </div>
            <div className="result-item-section result-item-case-schedules">
              <a href="#" className="schedule-link" onClick={e => onPetitionClick(e, row)}>
                Petition
              </a>
              {/* TODO: update URL */}
              {/* <a
              // href="/attorneys/export-csv/nysbke_171257"
              href="/attorneys/export-csv"
              className="csv-link"
            >
              Attorneys
            </a> */}
            </div>
          </div>
        );
      })}
      <ResultsPaginator
        totalPages={data.page_count}
        selectedPage={filter.page + 1 || 1}
        onChangePage={page => onSearch({ ...filter, page })}
      />
    </div>
  );
};

PetitionResults.propTypes = {
  data: PropTypes.any.isRequired,
  filter: PropTypes.any.isRequired,
  onSearch: PropTypes.func.isRequired,
  onGetPetitionPdf: PropTypes.func.isRequired,
};

export default PetitionResults;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/PetitionResults.jsx